export const access ={
    username: "acko",
    password: "I!^=[*{Gmx6Z",
}

/*
export const access ={
    username: "acko",
    password: "S9Lo]jEgoGfq",
}*/